var SpotEdit = {
	node :null,
	current: null,

	init: function() {
		SpotEdit.node = $("<div id='SpotEditor' class='cms-editor'></div>");

		if (player.cms) {
			SpotEdit.node.append(TPL.render("spot-edit-main", {}));
			$("#overlay").append(SpotEdit.node);
			
			setTimeout(function() {
	//			SpotEdit.node.find("input").on("keydown", function(evt) {
				$("#se_title").on("keydown", function(evt) {
					if (evt.keyCode == 9) {
						evt.stopPropagation();
					}
				});
				$("#se_no").on("keydown", function(evt) {
					if (evt.keyCode == 9) {
						evt.stopPropagation();
					}
				});
				$("#se_title2").on("keydown", function(evt) {
					if (evt.keyCode == 9) {
						evt.stopPropagation();
					}
				});
				$("#se_info").on("keydown", function(evt) {
					if (evt.keyCode == 9) {
						evt.stopPropagation();
					}
				});
				$("#link_type").on("change", function(evt) {
					SpotEdit.panels();
				});

				$("#panel-monument a").on("click", function(evt) {
					SpotEdit.editMonument();
					evt.preventDefault();
				});

				$("#spot-frame a").on("click", function(evt) {
					$("#spot-frame").hide();
				});

			}.bind(this), 200);

			AppEvent.on(player, "placeReady", SpotEdit.placeReady);
			AppEvent.on(player, "onProcess", SpotEdit.process);

//			player.cmsnode = $("<div class='cms'></div>");
			SpotEdit.addPlateButton = $("<a href='javascript:void(null);' onclick='SpotEdit.add();'><i class='fa fa-sign'></i><Br>Dodaj tabliczkę</a>");
//			SpotEdit.addUIElementButton = $("<a href='javascript:void(null);' onclick='SpotEdit.addUI();'><i class='fa fa-edit'></i><Br>Dodaj element</a>");
			player.cmsnode.append(SpotEdit.addPlateButton);			
//			player.cmsnode.append(SpotEdit.addUIElementButton);

//			$("#ui").append(player.cmsnode);
		}
	},

	panels: function() {
		var lt = $("#link_type").val();
		$("#panel-monument").hide();
		$("#panel-plate").hide();

		switch(lt) {
			case "monument":
				$("#panel-monument").show();
			break;

			default:
				$("#panel-plate").show();
		}
	},

	editMonument: function() {
		var id = $("#link_id").val();
		var furl = "/cms/index.php?mod=Monuments&action=edit&id=" + id + "&windowed=1";
		$("#spot-frame iframe").attr("src", furl);
		$("#spot-frame").show();
	},

	close: function() {
		$(".cms-editor").removeClass("open");
	},

	add: function() {

		var ind = HotSpotManager.spots.length + 1;

		var odx = dx;
		var ody = dy;

		var dx = Math.round((player.currentView.renderer.rx - 86) * 100) / 100;
		var dy = -1 * Math.tan(( Math.round(player.currentView.renderer.ry * 100) / -100 ) * (Math.PI/180)) * 1500;

		var spot = new panoramaHotSpot({'ident': "", 'spot': "1", 'x':dx, 'y':dy, "place": {"type": "indicator", "place_name": ""}}, ind, 0);
		//var spot = new panoramaHotSpot({'ident': idc.place_id, 'spot': "1", 'x':parseFloat(idc.look_x) + 1, 'y':parseFloat(idc.look_y) * -1, "place": {"type": "indicator", "place_name": idc.title}}, ind, 0);

		
		$("#se_x").val(dx);
		$("#se_y").val(dy);
		
		spot.indicator = {"look_x": dx, "look_y": dy, "title": "Pokój", "no": "", "title2": "", "info": ""};

		setTimeout(function() {spot.editor.moveToScreenCoords($(window).width() * 0.5, $(window).height() * 0.5);}, 10);

		spot.addHelper(
			$("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.fastTurnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")' class='indicator_left ind_title'>" + spot.indicator.title + "<br><small class='ind_title2'>" + spot.indicator.title2 + "</small><div class='arrow'></div></a>"), 
			$("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.fastTurnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")' class='indicator_right ind_title'>" + spot.indicator.title + "<br><small class='ind_title2'>" + spot.indicator.title2 + "</small><div class='arrow'></div></a>"));
		spot.helperWidth = 120;
		spot.tag = 'indicator';
		
		spot.node.html("<div class='indicator_plate indtoggle'><div class='plate'><b class='ind_title'>" + spot.indicator.title + "</b><Br><span class='ind_title2'>" + spot.indicator.title2 + "</span></div><a href='javascript:void(null);' class='more'><i class='fa fa-angle-down'></i></a><div class='panel'></div></div>");
		if (player.cms) {
			//spot.node.append("<div class='indicator_selected'></div>");			
			spot.editor.addUI();
		}
		spot.node.find(".indtoggle").on("click", function() {
			var m = $(this).find(".more");
			m.toggleClass("more_flipped");
			m.parent().find(".panel").toggleClass("panel_open")
		});
		spot.node.find(".indtoggle .more").hide();

		//spot.node.css("left", "-60px");
		HotSpotManager.add(spot);

		SpotEdit.select(spot.editor);
	},

	select: function(s) {
		$("#SpotEditor").removeClass("open");

		setTimeout(function() {
			if (s.hs.indicator != undefined) {
				$("#SpotEditor").addClass("open");
			}
		}, 100);

		if (SpotEdit.current !== s) {
			if (SpotEdit.current != null) SpotEdit.current.hs.node.find(".indicator_selected").hide();
			SpotEdit.current = s;

			s.hs.node.find(".indicator_selected").show();

			if (s.hs.indicator != undefined) {
				$("#link_type").val(s.hs.indicator.link_type);
				$("#link_id").val(s.hs.indicator.link_id);

				$("#se_title").val(s.hs.indicator.title);
				$("#se_no").val(s.hs.indicator.no);
				$("#se_title").val(s.hs.indicator.title);
				$("#se_no").val(s.hs.indicator.no);
				$("#se_title2").val(s.hs.indicator.title2);
				$("#se_info").val(s.hs.indicator.info);
				$("#se_hide").val(s.hs.indicator.hide == undefined ? 0 : s.hs.indicator.hide);
				$("#se_style").val(s.hs.indicator.hide == undefined ? 0 : s.hs.indicator.style);
				$("#se_x").val(parseFloat(s.hs.indicator.look_x) + parseFloat(player.current.properties.north) - 95);
				$("#se_y").val(s.hs.indicator.look_y);

				SpotEdit.panels();
			} else {
				if (s.hs.node3D)
					Cms.root.$refs.spotedit.open(SpotEdit.current);
				else
					Cms.root.$refs.spotedit2d.open(SpotEdit.current);
			}
		}
	},

	updateCoords: function(x,y) {
		$("#se_x").val(x);
		$("#se_y").val(y);
		if (SpotEdit.current.hs.indicator != undefined) {
			SpotEdit.current.hs.indicator.look_x = x;
			SpotEdit.current.hs.indicator.look_y = y;
		}
	},

	updateContent: function($title, $no, $title2, $info, hide, style, link_type, link_id) {
		SpotEdit.current.hs.indicator.link_type = link_type;
		SpotEdit.current.hs.indicator.link_id = link_id;
		SpotEdit.current.hs.indicator.title = $title;
		SpotEdit.current.hs.indicator.no = $no;
		SpotEdit.current.hs.indicator.title2 = $title2;
		SpotEdit.current.hs.indicator.info = $info;
		SpotEdit.current.hs.indicator.hide = (hide == undefined ? 0 : hide);
		SpotEdit.current.hs.indicator.style = (style == undefined ? 0 : style);

		SpotEdit.current.hs.node.find(".ind_title").html($title + " " + $no);
		SpotEdit.current.hs.node.find(".ind_title2").html($title2);
		SpotEdit.current.hs.node.find(".panel").html($info.replace(new RegExp('\n', 'g'), '<br>'));

		if ($info != "") SpotEdit.current.hs.node.find(".more").show();
		else SpotEdit.current.hs.node.find(".more").hide();
	},

	save: function() {
		var fields = {};		
		fields['link_type'] = $("#link_type").val();
		fields['link_id'] = $("#link_id").val();
		fields['look_x'] = parseFloat($("#se_x").val()) - parseFloat(player.current.properties.north) + 94; // bylo 95
		fields['look_y'] = $("#se_y").val();
		fields['title'] = $("#se_title").val();
		fields['no'] = $("#se_no").val();
		fields['title2'] = $("#se_title2").val();
		fields['info'] = $("#se_info").val();
		fields['hide'] = $("#se_hide").val();
		fields['style'] = $("#se_style").val();
		fields['place_id'] = player.ident;
		fields['id'] = SpotEdit.current.hs.indicator.id;

		SpotEdit.updateContent(fields['title'], fields['no'], fields['title2'], fields['info'], fields['hide'], fields['style'], fields['link_type'], fields['link_id']);

		$.post("/cms/index.php?mod=Panorama&action=addIndicator&ajax=1&pano=" + player.ident, fields, function(response) {
			if (fields['id'] == undefined || fields['id'] == null) {
				fields['id'] = response.indicator.id;
				SpotEdit.current.hs.indicator.id = response.indicator.id;
			}

			
			//alert("Zapisano");
		});
	},

	remove: function() {
		if (confirm("Czy na pewno chcesz usunąć tą tabliczkę ?")) {
			SpotEdit.current.hs.remove();
			$("#SpotEditor").removeClass("open");
			if (SpotEdit.current.hs.indicator.id != undefined && SpotEdit.current.hs.indicator.id != null && SpotEdit.current.hs.indicator.id > 0) {
				$.get("/cms/index.php?mod=Panorama&action=removeind&ajax=1&pano=" + player.ident + "&id=" + SpotEdit.current.hs.indicator.id, function(response) {
					console.log(response);
				});
			}
		}
	},

	placeReady: function(pe) {
	},

	process: function() {
	},
}

PluginManager.add(SpotEdit);